import React, { useState, useRef } from 'react';
import { SendIcon, MoonIcon, SunIcon, MenuIcon } from 'lucide-react';
import AlgaResponseWidget from './widgets/AlgaResponseWidget';
interface AlgaChatProps {
  onMenuClick?: () => void;
}
const AlgaChat: React.FC<AlgaChatProps> = ({
  onMenuClick
}) => {
  const [query, setQuery] = useState('');
  const [conversation, setConversation] = useState<Array<{
    type: 'user' | 'assistant';
    content: string;
  }>>([]);
  const [isTyping, setIsTyping] = useState(false);
  const [showWidgetResponse, setShowWidgetResponse] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    // Add user message to conversation
    setConversation([...conversation, {
      type: 'user',
      content: query
    }]);
    // Simulate typing
    setIsTyping(true);
    // Simulate assistant response after a delay
    setTimeout(() => {
      setIsTyping(false);
      setConversation(prev => [...prev, {
        type: 'assistant',
        content: 'Ecco alcune informazioni che potrebbero esserti utili:'
      }]);
      setShowWidgetResponse(true);
    }, 1500);
    setQuery('');
  };
  // Toggle dark mode
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  return <div className={`flex flex-col h-full ${isDarkMode ? 'bg-black' : 'bg-white'}`} data-id="element-72">
      <div className="flex justify-between items-center p-4 px-6 md:px-8 border-b border-gray-200" data-id="element-73">
        <div className="flex items-center" data-id="element-74">
          {/* Mobile menu button */}
          <button type="button" className="md:hidden -ml-1 mr-2 h-10 w-10 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none" onClick={onMenuClick} data-id="element-75">
            <span className="sr-only" data-id="element-76">Open sidebar</span>
            <MenuIcon className={`h-6 w-6 ${isDarkMode ? 'text-white' : 'text-gray-500'}`} aria-hidden="true" data-id="element-77" />
          </button>
          <div className="flex flex-col items-start" data-id="element-78">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYK3VqJh5ErppvW42Sa6wk/IMG_1178.png" alt="EIIS Logo" className="h-12 object-contain" data-id="element-79" />
            <p className="text-xs text-[#919191] mt-1" data-id="element-80">
              Powered by EIIS Intelligence
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2" data-id="element-81">
          <button onClick={toggleDarkMode} className={`p-2 rounded-full ${isDarkMode ? 'hover:bg-[#212121]' : 'hover:bg-gray-100'} transition-colors`} data-id="element-82">
            {isDarkMode ? <SunIcon size={24} className="text-gray-300" data-id="element-83" /> : <MoonIcon size={24} className="text-gray-600" data-id="element-84" />}
          </button>
        </div>
      </div>
      <div ref={chatContainerRef} className="flex-1 overflow-y-auto px-6 md:px-8 pb-6" data-id="element-85">
        <div className="max-w-3xl mx-auto" data-id="element-86">
          {conversation.length === 0 && <div className="flex flex-col items-center justify-center h-full" data-id="element-87">
              <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-pink-500 mb-6" data-id="element-88">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-89" />
              </div>
              <h2 className={`text-2xl font-semibold mb-2 ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`} data-id="element-90">
                Ciao, sono ALGA
              </h2>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} text-center max-w-lg mb-8`} data-id="element-91">
                Il tuo assistente AI personale. Posso aiutarti con informazioni
                sui corsi, suggerimenti di studio, e molto altro.
              </p>
              <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'} text-sm`} data-id="element-92">
                Prova a chiedermi qualcosa...
              </p>
            </div>}
          {conversation.length > 0 && <div className="space-y-6 pt-6" data-id="element-93">
              {conversation.map((message, index) => <div key={index} className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-94">
                  {message.type === 'assistant' && <div className="w-10 h-10 rounded-full overflow-hidden border-3 border-pink-500 mr-3 flex-shrink-0" data-id="element-95">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-96" />
                    </div>}
                  <div className={`max-w-[80%] p-3 rounded-lg ${message.type === 'user' ? 'bg-custom-green text-white rounded-tr-none' : isDarkMode ? 'bg-[#171717] text-gray-100 rounded-tl-none border border-[#171717]' : 'bg-gray-100 text-gray-800 rounded-tl-none'}`} data-id="element-97">
                    {message.content}
                  </div>
                </div>)}
              {isTyping && <div className="flex justify-start" data-id="element-98">
                  <div className="w-10 h-10 rounded-full overflow-hidden border-3 border-pink-500 mr-3 flex-shrink-0" data-id="element-99">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-100" />
                  </div>
                  <div className={`${isDarkMode ? 'bg-[#171717] text-gray-100 border border-[#171717]' : 'bg-gray-100 text-gray-800'} p-4 rounded-lg rounded-tl-none`} data-id="element-101">
                    <div className="flex space-x-1" data-id="element-102">
                      <div className={`w-2 h-2 ${isDarkMode ? 'bg-gray-500' : 'bg-gray-400'} rounded-full animate-bounce`} data-id="element-103"></div>
                      <div className={`w-2 h-2 ${isDarkMode ? 'bg-gray-500' : 'bg-gray-400'} rounded-full animate-bounce`} style={{
                  animationDelay: '0.2s'
                }} data-id="element-104"></div>
                      <div className={`w-2 h-2 ${isDarkMode ? 'bg-gray-500' : 'bg-gray-400'} rounded-full animate-bounce`} style={{
                  animationDelay: '0.4s'
                }} data-id="element-105"></div>
                    </div>
                  </div>
                </div>}
              {showWidgetResponse && <AlgaResponseWidget isDarkMode={isDarkMode} data-id="element-106" />}
            </div>}
        </div>
      </div>
      <div className={`border-t ${isDarkMode ? 'border-[#171717] bg-black' : 'border-gray-200 bg-white'}`} data-id="element-107">
        <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-108">
          <form onSubmit={handleSubmit} className="flex items-center" data-id="element-109">
            <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Scrivi un messaggio..." className={`flex-1 p-3 rounded-l-full focus:outline-none focus:ring-2 focus:ring-custom-green focus:border-transparent ${isDarkMode ? 'bg-[#171717] border border-[#171717] text-gray-100 placeholder-gray-400' : 'bg-white border border-gray-300 text-gray-800 placeholder-gray-500'}`} data-id="element-110" />
            <button type="submit" className="bg-custom-green text-white p-3 rounded-r-full hover:bg-custom-green/90 focus:outline-none focus:ring-2 focus:ring-custom-green" data-id="element-111">
              <SendIcon size={20} data-id="element-112" />
            </button>
          </form>
        </div>
      </div>
    </div>;
};
export default AlgaChat;